import React from "react";
import { useDispatch } from "react-redux";
import {
  Container,
  TopContainer,
  Subtitle,
  ButtonsContainer,
  Title,
  Spacer,
} from "./HomeInterfaceStyles";
import BlueButton from "../../UI/Button/CustomButtonLeftPanelBlue";
import GreenButton from "../../UI/Button/CustomButtonLeftPanelGreen";
import {
  setDrawModelDisplay,
  setSelectPatternDisplay,
} from "../../../redux/slices/display";

export default function HomeInterface() {
  // Redux dispatch function
  const dispatch = useDispatch();

  return (
    <Container>
      <TopContainer>
        <Title>Welcome to R2</Title>
        <Subtitle>Choose a training method</Subtitle>
        <ButtonsContainer>
          <BlueButton
            onClick={() => dispatch(setDrawModelDisplay())}
            width={250}
          >
            Draw Model
          </BlueButton>
          <Spacer />
          <GreenButton
            onClick={() => dispatch(setSelectPatternDisplay())}
            width={250}
          >
            Select Pattern
          </GreenButton>
        </ButtonsContainer>
      </TopContainer>
    </Container>
  );
}
